/**
 * Home Réassurance ASK — fade-in au scroll (IntersectionObserver)
 */
(function () {
  'use strict';
  if (window.__askReassReady) return;
  window.__askReassReady = true;

  function setupSection(section) {
    const items = section.querySelectorAll('[data-reass-item]');
    if (!items.length) return;
    if (!('IntersectionObserver' in window)) {
      items.forEach(i => i.classList.add('is-visible'));
      return;
    }
    const obs = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.3, rootMargin: '0px 0px -40px 0px' });
    items.forEach((it) => obs.observe(it));
  }

  function init() {
    document.querySelectorAll('[data-reass]').forEach(setupSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
